<router-outlet></router-outlet>
<div class="loading-container" *ngIf="loading$ | async">
  <nz-spin [nzTip]="'UTILS.LOADING' | translate"></nz-spin>
</div>